import { render, staticRenderFns } from "./SubmitModal.html?vue&type=template&id=d8fa8ab4&external"
import script from "./SubmitModal.vue?vue&type=script&lang=js"
export * from "./SubmitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports